module.exports = __webpack_public_path__ + "static/img/6.9d303ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/eng/6.png
// module id = bLvy
// module chunks = 0